import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import { faChartSimple, faCode, faSquarePollVertical } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.css']
})
export class InfoPageComponent {
  infoComponent: any[] = [];
  language!: string;
  routeSub!: Subscription;
  icons: { [key: string]: IconProp } = {
    faChartSimple: faChartSimple,
    faCode: faCode,
    faSquarePollVertical: faSquarePollVertical,
    faConnectdevelop: faConnectdevelop
  };
  constructor(
    private route: ActivatedRoute,
    private metaTagService: MetaTagService
  ) { }
  ngOnInit(): void {
    this.language = this.route.snapshot.url[0].path;
    this.routeSub = this.route.params.subscribe((params) => {
      if (params['lang']) {
        this.language = params['lang'];
        this.getResolverData()
      }
    })
    this.getResolverData()
  }
  getResolverData() {
    const resolverData = this.route.snapshot.data['infoData'];
    if (resolverData) {
      this.infoComponent = resolverData.infoComponents;
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error('Resolver data is undefined');
    }
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }
}
